import { FC } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Logo } from "../Logo/Logo";

export const SplashScreenLayout: FC = (): JSX.Element => {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "background.default",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: 'fixed',
        top: 0,
        right: 0,
        botom: 0,
        left: 0,
        zIndex: 1000
      }}
    >
      <Logo />
      <CircularProgress color="primary" />
    </Box>
  );
};
